import Blink from '@components/Blink'
import useTrackingUtils from '@components/Header/useTrackingUtils'
import usePageMetadata, { Breadcrumb } from '@hooks/usePageMetadata'
import { FunctionComponent, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

const LinkToSection = styled(Blink)`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55, brand_50 },
      },
    },
  }) => css`
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: ${brand_55};
    text-decoration: none;

    &:hover {
      color: ${brand_50};
    }
  `}
`

const Wrapper = styled.div`
  display: grid;
  justify-items: start;
  align-items: center;
  padding-left: 12px;
`

const Container = styled.div`
  display: grid;
  grid-gap: 12px;
  justify-items: start;
  grid-template-columns: auto 1fr;
  align-items: center;
`

const Article: FunctionComponent = () => {
  const { breadcrumbs, url } = usePageMetadata()
  const [linkToSection, setLinkToSection] = useState<Breadcrumb | undefined>()
  const { navbarClickTrackingFn } = useTrackingUtils({
    title: linkToSection?.title || '',
    url: linkToSection?.href || '',
  })

  useEffect(() => {
    if (breadcrumbs.length > 3) {
      setLinkToSection(breadcrumbs[2])
    } else if (breadcrumbs.length === 3) {
      setLinkToSection(breadcrumbs[1])
    }
  }, [url, breadcrumbs])

  if (!linkToSection) {
    return null
  }

  const { href, title } = linkToSection

  return (
    <Wrapper>
      <LinkToSection
        href={href}
        ariaLabel={title}
        onClick={navbarClickTrackingFn}>
        <Container>{title}</Container>
      </LinkToSection>
    </Wrapper>
  )
}

export default Article
